import { AbstractAccessor } from 'sdkore';

export class EntityAccessor extends AbstractAccessor {
    public constructor() {
        super('/public/entities');
    }
}
